import type { ValidChainId } from "@bracket/chainography/types";

export const getAdminRPCURL = ( chain: ValidChainId = 1, ): string => {
	const key = `CHAIN_${chain}_ADMIN_RPC`;
	if(key in globalThis.process.env) {
		const url = globalThis.process.env[`CHAIN_${chain}_ADMIN_RPC`];
		if(url) {
			return url;
		}
	}
	throw new Error(`@bracket/chainography getAdminRPCURL failed - CHAIN_${chain}_ADMIN_RPC not set in environment`);
}
